import { cn } from "@peerigon/pupper/tailwind";
import React from "react";

const Tags: React.FC<{
	tags: Array<string>;
	color?: string;
	isBlogPostFooter?: boolean;
}> = ({ tags, color, isBlogPostFooter }) => {
	const uniqueTags = Array.from(new Set(tags));
	// empty string should also fallback (hence the use of || instead of ??)
	// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
	const tagColor = color || "var(--color-gray-text)";

	return (
		<div
			className={cn("flex flex-wrap gap-[7px]", {
				"m-[80px_auto]": isBlogPostFooter,
				"m-[20px_0_0]": !isBlogPostFooter,
			})}
			style={
				{
					"--tag-color": tagColor,
					"--tag-color-alpha": `color-mix(in srgb, ${tagColor} 33%, transparent)`,
				} as React.CSSProperties
			}
		>
			{uniqueTags.map((tag) => (
				<div
					key={`${tag}-wrapper`}
					className="mt-px ml-px inline-block outline-1 outline-(--tag-color-alpha)"
				>
					<p className="font-regular leading-regular tracking-tiny m-0 p-[5px] font-sans text-[13px] text-(--tag-color) normal-case">
						{tag}
					</p>
				</div>
			))}
		</div>
	);
};

export default Tags;
